import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'
import { css } from 'lit'

export const tileTags = {
  gap: css`var(--csc-product-tile-tags-gap, ${csSpacing.spacing04})`
}

export const tileTagsStyle = css`
  .badge-group {
    display: flex;
    flex-direction: column;
    gap: ${tileTags.gap};
    min-width: 0;
  }

  .badge-group--inline {
    flex-direction: row;
    flex-wrap: wrap;
  }

  .badge-label {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    overflow-wrap: anywhere;
  }
`
